import React from "react"
import { NextSeo } from "next-seo"
import { webUrl } from "../../config/web"
import { Layout } from "../Layout/Layout"
import { PageHero } from "../IndexHero/PageHero"
import { css } from "@emotion/react"
import { md } from "../../styles/mediaQuery"
import Container from "../Layout/Container"
import { Section } from "../Section"
import { H2 } from "../blog/common"
import { CoursesList } from "../CoursesList/CoursesList"
import { Typography } from "antd"
import Link from "next/link"
import { SubscribeForm } from "../SubscribeForm/SubscribeForm"
import { Entry } from "contentful"
import { TypeProductEntitySkeleton } from "../../lib/contentful/ContentfulVzdelanibudoucnostiTypes"
import { ProductsColorsItem } from "../../lib/contentful/product/getAllProducts"

export const CoursePage: React.FC<Props> = ({ title, description, h1, text, h2, url, openSelectedCourses, openAnotherCourses, productsColors, children }) => {
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          url,
          title,
          description,
          images: [
            {
              url: `${webUrl}/images/header_laptop.jpg`,
              width: 1920,
              height: 1080,
              alt: "header_laptop"
            }
          ]
        }}
      />

      <Layout>
        <section>
          <PageHero
            h1={h1}
            text={
              <>
                <div
                  css={css`
                    ${md} {
                      font-size: 14px;
                    }
                  `}>
                  {text}
                </div>
              </>
            }></PageHero>
        </section>

        <Container>
          <Section
            css={css`
              padding: 20px 0 20px 0;
            `}>
            {h2 && <H2 level={2}>{h2}</H2>}

            {children ? children : null}

            <CoursesList
              courses={openSelectedCourses}
              productsColors={productsColors}
              css={css`
                margin: 20px 0 0 0;
              `}
            />

            {openAnotherCourses.length > 0 && (
              <>
                <H2
                  level={2}
                  css={css`
                    margin: 40px 0 0 0;
                  `}>
                  Ostatní naše otevřené kurzy
                </H2>
                <CoursesList
                  courses={openAnotherCourses}
                  productsColors={productsColors}
                  css={css`
                    margin: 20px 0 0 0;
                  `}
                />
              </>
            )}
          </Section>

          <Section>
            <H2 level={2}>Kurzy, které jsme v minulosti pořádali</H2>
            <Typography.Text>
              Máte zájem dozvědět se, které kurzy pro děti jsme v minulosti pořádali? <Link href="/poradali-jsme">Zde je jejich přehled</Link>.
            </Typography.Text>
          </Section>

          <Section>
            <H2 level={2}>Odběr novinek</H2>
            <SubscribeForm tags={["Krouzky", title]} />
          </Section>
        </Container>
      </Layout>
    </>
  )
}

interface Props {
  title: string
  description: string
  url: string
  h1: string
  text: React.ReactNode
  h2?: string
  openSelectedCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  openAnotherCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  productsColors: ProductsColorsItem[]
}
